import { setError } from "../../redux/actions";
import moment from "moment";
import { setNotif } from "../../redux/actions/app";
export const updateObject = (oldObject, updatedProps) => {
  return {
    ...oldObject,
    ...updatedProps,
  };
};

export const formatNumber = (num) => {
  return "IDR " + num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

export const stripMR = (val) => {
  let arr = val.split("");
  let text = "";
  arr.map((item, index) => {
    if (index > 0 && index % 2 === 0) {
      text += "-";
    }
    return (text += item);
  });
  return text;
};

export const parseToString = (val) => {
  return Number.isInteger(val) ? val.toString() : val;
};

export const toBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

export const isJSON = (payload) => {
  try {
    let o = JSON.parse(payload);
    if (o && typeof o === "object") {
      return true;
    }
  } catch (error) {
    return false;
  }
};

export const errorHandler = (dispatch, err) => {
  if (err.toString().includes("Network Error")) {
    dispatch(setError("connection"));
    return dispatch(
      setNotif({
        title: "Connection Error",
        subtitle: "Koneksi bermasalah, mohon coba kembali",
        open: true,
        type: "error",
      }),
    );
  } else if (err.response) {
    if (err.response.status === 500) {
      dispatch(setError("system"));
      return dispatch(
        setNotif({
          title: "System Error",
          subtitle: "Ada kesalahan, mohon coba kembali",
          open: true,
          type: "error",
        }),
      );
    } else if (err.response.status === 401 || err.response.status === 410) {
      dispatch(setError("not-authenticated"));
      return dispatch(
        setNotif({
          title: "Not Authenticated",
          subtitle: err.response.data.message || "Mohon login kembali",
          open: true,
          type: "error",
        }),
      );
    } else if (err.response.data) {
      return dispatch(
        setNotif({
          title: "Gagal",
          subtitle: err.response.data.message || "",
          open: true,
          type: "error",
        }),
      );
    } else {
      dispatch(setError("system"));
      return dispatch(
        setNotif({
          title: "System Error",
          subtitle: "Ada kesalahan, mohon coba kembali",
          open: true,
          type: "error",
        }),
      );
    }
  } else {
    dispatch(setError("system"));

    return dispatch(
      setNotif({
        title: "System Error",
        subtitle: "Ada kesalahan, mohon coba kembali",
        open: true,
        type: "error",
      }),
    );
  }
};

export const getDiffDay = (date) => {
  const now = moment().startOf("day");
  const end = moment(date);

  return now.diff(end, "days");
};

export const getDaysBetweenDates = (startDate, endDate) => {
  startDate = moment(startDate);
  endDate = moment(endDate);
  let now = startDate.clone();
  let dates = [];

  while (now.isSameOrBefore(endDate)) {
    let month = now.format("MMMM");
    // if (dates.length > 0) {
    //   console.log(Object.keys(dates[0])[0])

    // }
    if (now.day() !== 0) {
      let found = null;
      if (dates.length > 0) {
        found = dates.find((e) => Object.keys(e)[0] === month);
      }
      if (found) {
        let key = Object.keys(found)[0];
        found[key].push({
          date: now.format("YYYY-MM-DD"),
          month: month,
          day: now.format("ddd"),
          day_number: now.format("DD"),
        });
      } else {
        dates.push({
          [month]: [
            {
              date: now.format("YYYY-MM-DD"),
              month: month,
              day: now.format("ddd"),
              day_number: now.format("DD"),
            },
          ],
        });
      }

      // dates.push({
      //   date: now.format("YYYY-MM-DD"),
      //   month: month,
      //   day: now.format("ddd"),
      //   day_number: now.format("DD"),
      // });
    }

    now.add(1, "days");
  }

  return dates;
};

export const getTimeOfDay = (time) => {
  const hour = moment(time).hour(); // returns 0-23

  if (hour >= 5 && hour < 12) {
    return "pagi";
  } else if (hour >= 12 && hour < 18) {
    return "sore";
  } else {
    return "malam";
  }
};

export const getIndonesianDay = (dayNumber) => {
  const days = ["Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu", "Minggu"];
  return days[dayNumber - 1] || "";
};

export const IsIframe = () => {
  return window.self !== window.top;
};

export const truncateText = (text, maxChar) => {
  //ellipsis ...
  if (!text) return "";
  if (text.length <= maxChar) return text;
  return text.slice(0, maxChar) + "...";
};
